import { render, staticRenderFns } from "./CostCentreManagement.vue?vue&type=template&id=2fff661c&"
import script from "./CostCentreManagement.vue?vue&type=script&lang=js&"
export * from "./CostCentreManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports